import { FC, useState, useEffect } from 'react';
import { faChain } from '@fortawesome/pro-regular-svg-icons';

import RcsSectionBlock from './RcsSectionBlock';
import { CampaignSharingChain } from '@/apis/core/types';
import SharingChain from '../SharingChain';
import { campaignController } from '@/apis/core';

const ConnectivityChainSection: FC<{ campaignId: string }> = ({
  campaignId,
}) => {
  const [data, setData] = useState<CampaignSharingChain>();

  useEffect(() => {
    campaignController.getSharingChain(campaignId).then((res) => {
      setData(res);
    });
  }, [campaignId]);

  return (
    <RcsSectionBlock
      icon={faChain}
      title="Connectivity Chain"
      showDivider={true}
      data-testid="campaignConnectivityChain"
    >
      <SharingChain excludeTitle nodes={data?.nodes || []} />
    </RcsSectionBlock>
  );
};

export default ConnectivityChainSection;
